import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSaResources from './sa-resources.reducer';
import { SaResourcesState } from './sa-resources.state';

export const selectSaResourceState = createFeatureSelector<SaResourcesState>(
  fromSaResources.saResourceFeatureKey
);

export const getOverRideRto = createSelector(
  selectSaResourceState,
  (state) => state.resRto
);
